import {StrictMode} from "react";
import {createBrowserRouter, isRouteErrorResponse, RouterProvider, useRouteError} from "react-router-dom";
import {Layout} from "@/components/Layout";
import {FormPage} from "@/pages/form_page";
import {NoMatch} from "./pages/404";
import log from "loglevel";
import config from "config.json";
import {ServerError} from "@/pages/500";
import {FormSuccess} from "@/pages/form_page/success.tsx";
import {Main} from "@/pages/main";

log.setLevel(config.logging.level as log.LogLevelDesc);

// Add this new error boundary component
function ErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NoMatch/>;
  }

  return <ServerError/>;
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout/>,
    errorElement: <ErrorBoundary/>,
    children: [
      {
        path: '/reports/:id',
        element: <FormPage/>
      },
      {
        path: '/reports/:id/success',
        element: <FormSuccess/>
      }
    ]
  },
  {
    index: true,
    element: <Main/>
  },
  {
    path: '/404',
    element: <NoMatch/>,
  },
  {
    path: '*',
    element: <NoMatch/>,
  }
]);

function App() {
  return (
    <StrictMode>
      <RouterProvider router={router}/>
    </StrictMode>
  )
}

export default App


